import { render, staticRenderFns } from "./DashboardLayoutMyCoregEdit.vue?vue&type=template&id=3cd62ebc&"
import script from "./DashboardLayoutMyCoregEdit.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMyCoregEdit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMyCoregEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports